// Widget «مانده» BIL در سربرگ مشترک مراجعه‌کننده (COMP-PATIENT-HEADER: بخش `bil.balance`، فقط با bil.visit.view از سرور): بدهی گروه ادغام و پیوند مراجعه
// باز. کیف پول و پکیج فعال با AP-BIL-02 و 1b به همین بخش افزوده می‌شوند.
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { Money } from '@phoenix/ui';
import { Link as RouterLink } from 'react-router';
import type { PatientHeaderWidgetProps } from '../patients/headerWidgets';
import { visitPath } from './common';

export function BalanceWidget({ section }: PatientHeaderWidgetProps) {
  const { t } = useTranslation('bil');
  const value = (key: string) => section.entries.find((entry) => entry.key === key)?.value ?? null;
  const debt = Number(value('debt') ?? 0);
  const openVisit = value('open_visit_id');
  return (
    <Box data-testid="bil-balance-widget">
      <Typography variant="caption" color="text.secondary" component="div">
        {t('bil:summary.balance')}
      </Typography>
      <Typography variant="body2" color={debt > 0 ? 'error' : undefined} data-testid="bil-balance-debt" data-amount={debt}>
        {t('bil:summary.debt')}: <Money amountMinor={debt} />
      </Typography>
      {openVisit ? (
        <Typography variant="body2">
          <Link component={RouterLink} to={visitPath(openVisit)} data-testid="bil-balance-open-visit">
            {t('bil:summary.open_visit')}
          </Link>
        </Typography>
      ) : null}
    </Box>
  );
}
